import { observer } from 'mobx-react-lite';
import { IonSlides, IonSlide, IonText, IonButton } from '@ionic/react';

import fuelingPlanStore from 'stores/fueling-plan.store';

import FuelingInfoCotainer from 'pages/fueling-plan/components/FuelingInfoCotainer';
import Loader from 'pages/fueling-plan/components/FuelingInfoCotainer/Loader';

import { sliderConfig } from 'config.json';
import classes from './style.module.scss';

const WorkoutPrograms = ({ match, history }) => {
  const fuelingPlans = fuelingPlanStore.getObjects();
  const isLoading = fuelingPlanStore.getIsLoading();

  return (
    <div className={classes.mainContainer}>
      <div className={classes.title}>
        <IonText className='big'>Fueling Plan</IonText>
        <IonButton
          onClick={() => history.push('/fueling-plans')}
          fill='clear'
          size='small'
        >
          <IonText className='small'> View All</IonText>
        </IonButton>
      </div>
      <div className={classes.content}>
        {!isLoading ? (
          fuelingPlans.length > 0 ? (
            <IonSlides options={sliderConfig}>
              {fuelingPlans.map((fuelingPlan, index) => (
                <IonSlide className={classes.ionSlide} key={fuelingPlan.id}>
                  <div
                    className={classes.FuelingPlanContainer}
                    onClick={(e) => {
                      e.stopPropagation();
                      history.push(`/fueling-plans?slide=${index}`);
                    }}
                  >
                    <FuelingInfoCotainer fuelingPlan={fuelingPlan} />
                  </div>
                </IonSlide>
              ))}
            </IonSlides>
          ) : (
            'No Data available'
          )
        ) : (
          <div className={classes.FuelingPlanContainer}>
            <Loader />
          </div>
        )}
      </div>
    </div>
  );
};

export default observer(WorkoutPrograms);
